module.exports = " <a class=vux-button-tab-item :class=classes href=javascript: :style=style @click=onItemClick> <slot></slot> </a> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/button-tab/button-tab-item.vue
// module id = 204
// module chunks = 2